// extracted by mini-css-extract-plugin
export default {"exit":"ProfileMobile_exit__vKAW8"};